import './App.css';
import Footer from './Components/Footer';
import Nav from './Components/Nav';
import Navbar from './Components/Navbar';
import AllRoutes from './Routes/AllRoutes';

function App() {
  return (
    <>
    <Nav/>
    <Navbar/>
    <AllRoutes/>
    <Footer/>  
    </>
  );
}

export default App;
